import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";

export function ForgotPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot", { email }); setSent(true); }
    catch { toast.error("Erreur"); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-md mx-auto px-6 py-20" data-testid="forgot-page">
        <h1 className="text-3xl font-serif text-primary mb-2">Mot de passe oublié ?</h1>
        <p className="text-slate-500 mb-8 text-sm">Saisissez votre e-mail — nous vous enverrons un lien pour choisir un nouveau mot de passe.</p>
        {sent ? (
          <div className="p-4 bg-emerald-50 border border-emerald-200 rounded-md flex items-start gap-3 text-sm" data-testid="forgot-sent">
            <Mail className="w-4 h-4 mt-0.5 text-emerald-600" />
            <p className="text-emerald-800">Si un compte existe pour cet e-mail, un lien de réinitialisation a été envoyé. Vérifiez votre boîte de réception (valide 1 heure).</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email"
              placeholder="votre-email@exemple.com" autoComplete="email"
              className="w-full border border-slate-300 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:border-primary" />
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full bg-primary hover:bg-[hsl(var(--primary-light))] disabled:opacity-50 text-white font-medium py-2.5 rounded-md text-sm inline-flex items-center justify-center gap-2">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Envoyer le lien
            </button>
          </form>
        )}
        <p className="mt-6 text-xs text-center"><Link to="/login" className="text-primary underline">Retour à la connexion</Link></p>
      </main>
      <Footer />
    </div>
  );
}

export function ResetPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) return toast.error("Mots de passe différents");
    if (pwd.length < 10) return toast.error("Minimum 10 caractères");
    setLoading(true);
    try {
      await api.post("/auth/reset", { token, new_password: pwd });
      toast.success("Mot de passe modifié");
      nav("/login");
    } catch (err) { toast.error(err?.response?.data?.detail || "Erreur"); }
    finally { setLoading(false); }
  };
  if (!token) return <div className="min-h-screen flex items-center justify-center">Lien invalide</div>;
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-md mx-auto px-6 py-20" data-testid="reset-page">
        <h1 className="text-3xl font-serif text-primary mb-6">Nouveau mot de passe</h1>
        <form onSubmit={submit} className="space-y-4">
          <input type="password" required minLength={10} value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="reset-pwd"
            placeholder="Nouveau mot de passe (min 10)" className="w-full border border-slate-300 rounded-md px-3 py-2.5 text-sm" />
          <input type="password" required minLength={10} value={pwd2} onChange={(e) => setPwd2(e.target.value)} data-testid="reset-pwd2"
            placeholder="Confirmer" className="w-full border border-slate-300 rounded-md px-3 py-2.5 text-sm" />
          <button type="submit" disabled={loading} data-testid="reset-submit"
            className="w-full bg-primary hover:bg-[hsl(var(--primary-light))] disabled:opacity-50 text-white font-medium py-2.5 rounded-md text-sm inline-flex items-center justify-center gap-2">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Valider
          </button>
        </form>
      </main>
      <Footer />
    </div>
  );
}
